var map = {
	"./admin/admin.module": [
		512,
		0
	],
	"./pages/pages.module": [
		513,
		3
	],
	"./recruiter/recruiter.module": [
		514,
		1
	],
	"./talent/talent.module": [
		515,
		2
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 175;



//////////////////
// WEBPACK FOOTER
// ./src async
// module id = 175
// module chunks = 6